import { useQuery } from '@tanstack/react-query';
import axios from '../../utils/axiosInstance';
import { Brand, Campaign, CampaignAsset, Task } from '../types';

export interface SearchResults {
  query: string;
  brands: Brand[];
  campaigns: Campaign[];
  assets: CampaignAsset[];
  tasks: Task[];
}

export const useGlobalSearch = (query: string, enabled = true) =>
  useQuery({
    queryKey: ['search', query] as const,
    enabled: enabled && query.trim().length >= 2,
    queryFn: async () => {
      const res = await axios.get<SearchResults>(`api/search/?q=${encodeURIComponent(query.trim())}`);
      return res.data;
    },
    staleTime: 10_000,
  });
